/**
 * C.11 / M.2 — NIPE tool schemas.
 *
 * Transport-layer barrel. The actual schemas now live alongside their
 * handlers in `./tools/<toolName>.ts`. This file re-exports the
 * combined schema array + the OpenAI-style serializer.
 *
 * @see ./tools/README.md for the per-tool catalog.
 *
 * Per Q25, NIPE never auto-loads Skills — it always asks via tool calls.
 */

import { ALL_TOOL_SCHEMAS, type NipeToolSchema } from './tools';

/**
 * @deprecated Use `NipeToolSchema` from `./tools/types` instead. Kept
 * for backward compatibility.
 */
export type SkillTool = NipeToolSchema;

/**
 * The full NIPE tool schema list. Order matches `ALL_TOOLS` for prompt-
 * cache friendliness.
 */
export const SKILL_TOOLS: NipeToolSchema[] = [...ALL_TOOL_SCHEMAS];

/** Serialized payload shape for transport to the Convex action. */
export interface SerializedTool {
  name: string;
  description: string;
  parametersJson: string;
}

export function serializeTools(
  tools: NipeToolSchema[] = SKILL_TOOLS,
): SerializedTool[] {
  return tools.map((t) => ({
    name: t.function.name,
    description: t.function.description,
    parametersJson: JSON.stringify(t.function.parameters),
  }));
}
